import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { bindActionCreators, Dispatch, Action } from 'redux'

import AddressBar from './AddressBar'

import { simulationAddressSelector } from '@/checkout-instore-legacy/cart/simulation/selectors'
import { countryCodeSelector } from '@/checkout-instore-legacy/order/selectors'
import { getCustomerNameSelector } from '@/checkout-instore-legacy/customer/selectors'
import { setPostalCodeSession } from '@/checkout-instore-legacy/session/actions'

export const mapStateToPropsSelector = createStructuredSelector({
  simulationAddress: simulationAddressSelector,
  countryCode: countryCodeSelector,
  receiverName: getCustomerNameSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ setPostalCodeSession }, dispatch)

export default connect(mapStateToPropsSelector, mapDispatchToProps)(AddressBar)
